import axios from 'axios';

const api = axios.create({
  baseURL: `https://vox-backend-8dda4efc8a1a.herokuapp.com/`
  // baseURL: `http://localhost:3001`
});

export default api;
//177.55.164.244